import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=d8882f70&scoped=true"
import script from "./userHeader.vue?vue&type=script&lang=js"
export * from "./userHeader.vue?vue&type=script&lang=js"
import style0 from "./userHeader.vue?vue&type=style&index=0&id=d8882f70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8882f70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8882f70')) {
      api.createRecord('d8882f70', component.options)
    } else {
      api.reload('d8882f70', component.options)
    }
    module.hot.accept("./userHeader.vue?vue&type=template&id=d8882f70&scoped=true", function () {
      api.rerender('d8882f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/userHeader.vue"
export default component.exports